export default {
  title: 'Policy Management',
  menu: 'Policy Management',
  ajingaPolicyManagement: 'AJINGA Policy Management',
  label: {
    createTime: 'Create Date',
    policyZhName: 'Name (Chinese)',
    policyEnName: 'Name (English)',
    policyType: 'Type',
    policyCreator: 'Creator',
    policyOpenStatus: 'Status',
    policyOperate: 'Action',
    PRIVACY: 'AJINGA Privacy Policy',
    TOS: 'AJINGA User Agreement',
    createAgreementTitle: 'Create',
    viewAgreementTitle: 'View',
    editAgreementTitle: 'Edit',
    agreementCategory: 'Policy Type',
    agreementCnContent: 'Policy (Chinese)',
    agreementEnContent: 'Policy (English)',
    agreementStyle: 'Policy Style',
    agreementFile: 'Policy Attachment',
    statementPreview: 'Above \'APPLY\' button',
    statePreviewTitle: 'The policy name is displayed above the \'Apply\' button.',
    example: 'Example:',
    statementPop: 'Pop-up',
    statementPopTitle: 'When the applicant clicks the \'Apply\' button, the policy content will be displayed in a popup window, which is suitable for multiple policies.\'',
    agreementCnName: 'Policy Content (Chinese)',
    agreementEnName: 'Policy Content (English)',
    agreementType: 'Agreement Type',
    link: 'Link',
    file: 'File',
    text: 'Text',
    agreementCn: '(Chinese)',
    agreementEn: '(English)',
    uploadTip: 'Drag the file here, or ',
    clickUpload: 'Click to Upload',
    uploadCheck: 'Only PDF files can be uploaded and cannot exceed 3MB',
    addStatementPopAgreement: 'Add a new policy need to be consented',
    popTitle: 'Pop-up Title',
    chinese: 'Chinese',
    english: 'English',
    acceptBtn: 'Accept Button',
    declineBtn: 'Decline Button',
    notification: 'Campaign Subscription Consent',
    satisfaction: 'Satisfaction Survey Consent',
    required: 'Required',
    yes: 'Yes',
    no: 'No',
    uploadingText: 'Uploading…',
    uploadingFinish: 'Successfully uploaded.',
    uploadHere: 'Upload',
    selectFileUpload: 'Please select file to upload',
    employeeAgreed: 'I am acknowledged ',
    employeeRegisterPolicy: 'Zegna GCR Internal Referral Policy',
    revokeEmailAddress: 'Send email when candidate revoke application(s) to'
  },
  placeholder: {

  },
  btn: {
    viewPolicy: 'View',
    editPolicy: 'Edit',
    deletePolicy: 'Delete',
    addNewVersion: 'Add',
    confirm: 'Confirm',
    cancel: 'Cancel'
  },
  message: {
    updateEnabled: 'Successfully updated.',
    deleteOrNot: 'This action will permanently delete the policy, do you want to continue?',
    updateEnable: 'The policy will not be editable after enabled, do you want to continue?',
    deletePoint: 'Tip',
    deleteSuccess: 'Successfully deleted.',
    deleteFail: 'Delete failed',
    deleteCancel: 'The deletion has been canceled',
    updateSuccess: 'Updated Success',
    createSuccess: 'Successfully created',
    cancelEnabled: 'Status change cancelled',
    copyFileUrl: {
      success: 'Successfully copied.',
      fail: 'Failed to copy. Please try again.'
    },
    deletePolicyFileError: 'This link is already in use, please delete it first.',
    fileTypeError: 'You can only upload a file no more than 10MB, and the acceptable file types include \'pdf\', \'doc\', \'docx\'',
    fileSizeError: 'The file size must be less than 10Mb',
    notClosePolicy: 'The policy cannot be disabled. Ensure that only one of this type is enabled.',
    employeeAgreePolicyWarning: 'Please agree to the agreement',
    onlyOneNotification: 'Oops, you can only configure ONE campaign subscription consent',
    onlyOneSatisfaction: 'Oops, you can only configure ONE satisfaction subscription consent',
    consentUpdated: 'Please read and agree to the latest consent'
  }
}
